// import 'Styles/themes/_wiski-critical.scss';

// TODO remove for prod
import 'Styles/styles.scss';

// This import will add Promise to the window.
import "promiscuous/dist/promiscuous-browser-shim-full";

// Formulate customizations.
import "./components/formulate/brite-verify-validation";

// Formulate plain JavaScript frontend.
import "../responsive.plain-javascript/plain-index";

import "./lib/polyfills";

import { each } from './lib/util';
import HeaderComponent from './header/header';
import FooterComponent from './footer/footer';
import GraphicalCalloutCarousel from './widgets/graphical-callout-carousel/graphical-callout-carousel.widget';
import GraphicalCalloutGrid from './widgets/graphical-callout-grid/graphical-callout-grid.widget';
import AccordionComponent from './components/accordion';
import ModalComponent from './components/modal/modal';
import AttractionDetails from './widgets/attraction-details/attraction-details.widget';
import AttractionGallery from './widgets/attraction-gallery/attraction-gallery.widget';
import CompoundCalloutList from './widgets/compound-callout-list/compound-callout-list.widget';
import ChatComponent from './components/chat/chat';
import DirectoryComponent from './widgets/directory/directory.widget';
import StoreDetailsComponent from './widgets/store-details/store-details.widget';
import BgComponent from './components/bg-img/bg-img';
import ValidationComponent from './forms/validation';
import Hero from './widgets/hero/hero.widget';
import GraphicalBanner from './widgets/graphical-banner/graphical-banner.widget';
import FeaturedCardsCalloutCarousel from './widgets/featured-cards-callout-carousel/featured-cards-callout-carousel.widget';
import NewsCarousel from './widgets/news-carousel/news-carousel.widget';
import './widgets/offer-carousel/offer-carousel.widget';
import './widgets/product-carousel/product-carousel.widget';
import './services/animations';
import ImprovPageComponent from './widgets/movies/improv.widget';
import MovieTheaterFeaturesComponent from './widgets/movies/movies-theater-features.widget';
import EmergencyAlertComponent from './components/emergency-alert/emergency-alert';
import FormComponent from './widgets/form/form.widget';
import FormsModule from './forms/forms';
import CurbsideToGo from './curbside-to-go/curbside-to-go';
import KidsBirthdayClubForm from './widgets/kids-birthday-club-form/kids-birthday-club-form.widget';
import AugmentedRealityExperience from './widgets/augmented-reality-experience/augmented-reality-experience.widget';
import EventsCarousel from './widgets/events-carousel/events-carousel.widget';
import SimpleGraphicalCalloutGrid from './widgets/simple-graphical-callout-grid/simple-graphical-callout-grid';
import TrackingEventsComponent from './components/tracking-events/tracking-events';
import EventPromotionDetailWidget from './widgets/events-promotions-details/events-promotions-details.widget';
import MoviesComponent from './widgets/movies/movies.widget';
import WifiFormComponent from './widgets/wifi-form/wifi-form.widget';
// list of components that will fire conditionally depending on whether
// the static selector property on them matches any dom elements
const components = [
    HeaderComponent,
    ModalComponent,
    TrackingEventsComponent,
    GraphicalCalloutCarousel,
    AccordionComponent,
    AttractionDetails,
    AttractionGallery,
    GraphicalCalloutGrid,
    CompoundCalloutList,
    FormComponent,
    FooterComponent,
    ChatComponent,
    DirectoryComponent,
    ValidationComponent,
    StoreDetailsComponent,
    Hero,
    GraphicalBanner,
    FeaturedCardsCalloutCarousel,
    NewsCarousel,
    MoviesComponent,
    MovieTheaterFeaturesComponent,
    ImprovPageComponent,
    MovieTheaterFeaturesComponent,
    EmergencyAlertComponent,
    CurbsideToGo,
    KidsBirthdayClubForm,
    AugmentedRealityExperience,
    EventsCarousel,
    SimpleGraphicalCalloutGrid,
    EventPromotionDetailWidget,
    WifiFormComponent
];

if (typeof DEVELOPMENT !== 'undefined' && DEVELOPMENT) {
    window.cssLoaded = true;
}





function init() {
    let apiMap = {};
    var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
    if (touchsupport){ // browser doesn't support touch
        document.documentElement.classList.add('js-touch');
    }

    var is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent),
        is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

    if (is_ios) {
        document.documentElement.classList.add('is-ios');
    }
    if (is_ios && is_safari) {
        document.documentElement.classList.add('is-safari');
    }

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isEdge = window.navigator.userAgent.indexOf("Edge") > -1
    if (isIE11 || isEdge) {
        document.documentElement.classList.add('js-ie');
    }

    components.forEach((cmp) => {
        initComponent(cmp);
    });

    // Components that require other components to funciton
    const bgCmps = BgComponent.getEntryElements();
    each(bgCmps, (cmp) => {
        new BgComponent(cmp, document.querySelector('.graphical-callout-grid'),
                            document.querySelector('.ww-graphical-callout-carousel'))
    })

    new FormsModule();
}

function initComponent(cmp) {
    let cmpsOnPage = cmp.getEntryElements();
    if(cmpsOnPage.length) {

        each(cmpsOnPage, (el) => {
            if(cmp.fetch && cmp.template) {
                cmp.fetch().then(data => {
                    const cmpInstance = data === undefined ? cmp.fromErrorTemplate(cmp.error) : cmp.fromTemplate(data);
                    el.parentElement.replaceChild(cmpInstance.el, el);
                }).catch(err => console.error(err));
            }else{
                new cmp(el);
            }
        })


    }else{
        return false;
    }
}

if(document.readyState === 'complete') {
    init();
 }else{
     window.addEventListener('load', init);
 }